export default "<p>legal-form works!</p>\n"